import React, { useEffect, useState } from "react";
import mammoth from "mammoth";
import styled from "styled-components";
import Footer from "../../privacy-policy/Footer";

const Parallax = styled.div`
  background-image: url("/images/parallax.jpg");
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 10px;
`;

const SquareBox = styled.div`
  background-color: rgba(255, 255, 255, 0.66);
  margin: clamp(5px, 5vw, 10px);
  padding: clamp(15px, 5vw, 100px);
`;

const BackButton = styled.button`
  position: fixed;
  bottom: 30px;
  left: 30px;
  background-color: #caaeecff;
  color: white;
  font-family: 'Mozilla Text', serif;
  font-size: clamp(1rem, 2vw, 1.5rem);
  font-weight: bold;
  padding: 10px;
  border: none;
  border-radius: 15px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  box-shadow: 0 4px 6px rgba(0,0,0,0.2);

  &:hover {
    background-color: #ba9debff;
  }
`;

const Title = styled.h1`
  color: #0360ffa2;
  text-align: center;
  font-family: 'MedievalSharp', serif;
  font-size: clamp(1.5rem, 5vw, 2.8rem);
  padding-bottom: clamp(15px, 3vw, 25px);
`;

const SampleText = styled.div`
  color: #2b60bdff;
  font-family: 'Mozilla Text', serif;
  font-size: clamp(1rem, 2vw, 1.5rem);
  line-height: 1.6;

  p {
    padding-bottom: clamp(15px, 3vw, 25px);
  }
`;

const WhenTheButterfliesAreGoneSample = () => {
  useEffect(() => {
    document.title = "When The Butterflies Are Gone Sample - Anna Miki";
  }, []);

  const [content, setContent] = useState("");

  useEffect(() => {
    fetch("/samples/when-the-butterflies-are-gone-sample.docx")
      .then((res) => res.arrayBuffer())
      .then((arrayBuffer) =>
        mammoth.convertToHtml({ arrayBuffer }).then((result) => {
          setContent(result.value);
        })
      );
  }, []);

  const handleBack = () => {
    window.location.href = "/when-the-butterflies-are-gone";
  };

  return (
    <Parallax>

      <SquareBox>

        <BackButton onClick={handleBack}>Close</BackButton>

        <Title>
          Sample from <br/>
          <p style={{ fontStyle: "italic" }}>When The Butterflies Are Gone</p>
        </Title>
        
        <SampleText dangerouslySetInnerHTML={{ __html: content }} />

      </SquareBox>

      <Footer />
 
    </Parallax>
  );
};

export default WhenTheButterfliesAreGoneSample;
